import {
    BLOCKUNBLOCKUSER_SUCCESS,
    BLOCKUNBLOCKUSER_FAILED,
    RESET_BLOCKUNBLOCKUSER,
    LOADING_BLOCKUNBLOCKUSER,
    NETWORK_ERROR_BLOCKUNBLOCKUSER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_BLOCKUNBLOCKUSER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case BLOCKUNBLOCKUSER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case BLOCKUNBLOCKUSER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_BLOCKUNBLOCKUSER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_BLOCKUNBLOCKUSER:
            return (state = initialState);
        default:
            return state;
    }
};
